module.exports = __webpack_public_path__ + "static/media/ck.fe45a10b.svg";